module.exports = __webpack_public_path__ + "63931d2cc6f1e496ef14ef268c660ac7.xlsx";